import { render } from "./YUpload.vue?vue&type=template&id=ecb47936&scoped=true"
import script from "./YUpload.vue?vue&type=script&lang=js"
export * from "./YUpload.vue?vue&type=script&lang=js"

import "./YUpload.vue?vue&type=style&index=0&id=ecb47936&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb47936"]])

export default __exports__